<template>
    <div class="middle-content">
        <div id="map-blur" class="map-blur">
            <div class="map-blur-text">
                <h2 class="">Bem-vindo ao GIG</h2>
                <p v-if="!hasError">
                    Seu email foi confirmado com sucesso!
                </p>
                <p v-else>
                    Ocorreu um erro! Por favor tente novamente.
                </p>
                Você será redirecionado em: {{cooldownValue}}
            </div>
            <div class="map-blur-image"></div>
        </div>
        <div id="map-container" class="map-container on-left"></div>
    </div>
</template>

<script>
import { CONFIG } from '../../config';

export default {
    name: 'validate-email',

    props: {
        token: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            cooldownValue: 3,
            hasError: false,
            rootUrl: `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`
        };
    },

    methods: {
        _success () {
            this.hasError = false;
            setInterval(() => {
                this.cooldownValue--;
                if (this.cooldownValue <= 0) {
                    window.location = this.rootUrl;
                }
            }, 1000);
        },

        _error () {
            this.hasError = true;
            setInterval(() => {
                this.cooldownValue--;
                if (this.cooldownValue <= 0) {
                    window.location = this.rootUrl;
                }
            }, 1000);
        }
    },

    mounted () {
        this.$http.get(`${CONFIG.URL.API_HOST}/users/ConfirmEmail?token=${this.token}`)
            .then(this._success, this._error);
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/validate-email/validate-email.vue